<template>
    <v-container>

        <!--------------------------------------->
        <!--         Day Card Iterator         -->
        <!--------------------------------------->
        <v-row
            class="my-7"
            no-gutters
        >
            <v-col>
                <v-expansion-panels
                    hover
                    popout
                    focusable
                >
                    <v-expansion-panel
                        v-for="(day,d) in mealTimes"
                        :key="d"
                    >

        <!--------------------------------------->
        <!--          Header Contents          -->
        <!--------------------------------------->
                        <v-expansion-panel-header>
                            <v-col
                                class = "text-left, d-flex"
                            >
                                <h3>{{ day.day }}</h3>
                            </v-col>
                        </v-expansion-panel-header>
        
        <!--------------------------------------->
        <!--        Expansion Contents         -->
        <!--------------------------------------->
                        <v-expansion-panel-content>
                            <v-container flex class="pa-2 mt-3">
                                <v-row>

        <!--------------------------------------->
        <!--    Initialize Edit Meal Dialog    -->
        <!--------------------------------------->
                                    <v-dialog
                                        v-model="editMealDialog"
                                        persistent
                                        width="500"
                                        style="overflow-x: hidden"
                                    >
                                        <template
                                            v-slot:activator="{ on }"
                                        >
                                            <v-row>
                                                <v-col
                                                    v-for="(detail,l) in day.details"
                                                    :key="l"
                                                    class = "text-center pa-0 ma-0"
                                                    cols="6"
                                                    xs="6"
                                                    sm="4"
                                                    md="4"
                                                    lg="2"
                                                    xl="2"
                                                >
                                                    <v-card
                                                        class="ma-2 pa-2"
                                                        raised
                                                        style="height: 100px;"
                                                        v-on="on"
                                                        @click.prevent="editMeal(detail.id,detail.meal_type)"
                                                    >
                                                        <!-- <v-btn
                                                            absolute
                                                            dark
                                                            icon
                                                            small
                                                            color="blue"
                                                            style="top: 3px; right: 3px;"
                                                        >
                                                            {{l}}
                                                        </v-btn> -->
                                                        <h4>
                                                            {{detail.meal_type.charAt(0).toUpperCase() + detail.meal_type.slice(1)}}
                                                        </h4>

                                                        <v-row
                                                            class="mt-2"
                                                            justify="center"
                                                            no-gutters
                                                        >
                                                            <h5
                                                                v-if="detail.food_type_lookup != null"
                                                                class="text-no-wrap"
                                                            >   
                                                                {{detail.food_type}}
                                                            </h5>
                                                            <h5
                                                                v-else
                                                                class="text-no-wrap"
                                                            >
                                                                {{detail.plan_type}}
                                                            </h5>
                                                        </v-row>

                                                        <v-row
                                                            justify="center"
                                                            class="mt-1"
                                                            no-gutters
                                                        >
                                                            <v-icon
                                                                color="grey darken-3"
                                                                class="mr-1"
                                                            >
                                                                av_timer
                                                            </v-icon>
                                                            <h5
                                                                class="text-no-wrap"
                                                            >
                                                                {{detail.minutes_available_to_prepare}} min
                                                            </h5>
                                                        </v-row>
                                                    </v-card>
                                                </v-col>
                                            </v-row>
                                        </template>

        <!--------------------------------------->
        <!--     Edit Meal Dialog Contents     -->
        <!--------------------------------------->
                                        <v-card
                                            class="pa-0 ma-0"
                                            style="overflow: hidden"
                                        >
                                            <v-toolbar
                                                color="grey lighten-3"
                                            >
                                                <v-row
                                                    align="center"
                                                    no-gutters
                                                >
                                                    <v-card-title
                                                        class="headline ml-2 pa-0 my-0"
                                                        primary-title
                                                    >
                                                        Edit {{mealToEdit}}
                                                    </v-card-title>
                                                    <v-btn
                                                        absolute
                                                        small
                                                        fab
                                                        class="mr-3 text-right"
                                                        style="top: 10px; right: 10px;"
                                                        @click="closeEditMeal"
                                                    >
                                                        <v-icon>
                                                            close
                                                        </v-icon>
                                                    </v-btn>
                                                </v-row>
                                            </v-toolbar>
                                            <v-row
                                                class="pa-5"
                                                no-gutters
                                            >
                                                <v-col>
                                                    <EditMeal/>
                                                </v-col>
                                            </v-row>
                                        </v-card>
                                    </v-dialog>

                                </v-row>
                            </v-container>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>

            </v-col>
        </v-row>
    </v-container>
</template>


<script>
import EditMeal from '@/components/schedule/editMeal.vue'

let moment = require('moment');

export default {

    components: {
        EditMeal,
    },

    data: () => ({
        moment: moment,
        mealToEdit: null,
    }),

    methods: {
        editMeal(id,meal) {
            this.$store.dispatch('data/updateMealTimeToEdit',id);
            this.editMealDialog = true;
            this.mealToEdit = meal.charAt(0).toUpperCase() + meal.slice(1);
        },
        closeEditMeal() {
            this.$store.dispatch('data/updateMealTimeToEdit',null);
            this.editMealDialog = false;
        },
    },

    computed: {
        mealTimes() {
            let data = this.$store.getters['data/mealTime']
            let max = data.length
            let result = []
            let day = null

            for (let d = 0; d < 7; d++) {
                if (d == 0) {
                    day = 'Sunday'
                } else if (d == 1) {
                    day = 'Monday'
                } else if (d == 2) {
                    day = 'Tuesday'
                } else if (d == 3) {
                    day = 'Wednesday'
                } else if (d == 4) {
                    day = 'Thursday'
                } else if (d == 5) {
                    day = 'Friday'
                } else if (d == 6) {
                    day = 'Saturday'
                }
                result.push({day: day,details: []})
                for (let i = 0; i < max; i++) {
                    if (data[i].day_of_week == d){
                        result[d].details.push(data[i])
                    }
                }
            }

            // console.log('result:',result)
            return result;
        },
        editMealDialog: {
            get(){
                return this.$store.getters['data/editMealDialog'];
            },
            set(value) {
                this.$store.dispatch('data/updateEditMealDialog',value);
            }
        },
    }
};
</script>
